export default function mcLoadingScreenPromiseTracker(McPromiseTracker) {
  return new McPromiseTracker();
}

mcLoadingScreenPromiseTracker.$inject = ['McPromiseTracker'];
